import { MAINTAB } from '../_constants/actionConstants';
import { tabToPath } from '../_helpers/urlHelpers';

/**
 * Redux middleware that keeps the browser URL in sync with the active tab.
 *
 * Listens to:
 *   MAINTAB.SELECT        — tab switched (also fires immediately after MAINTAB.ADD)
 *   MAINTAB.CHANGE_METADATA — tab data updated (e.g. docId set after an ADR loads)
 *   MAINTAB.CLOSE_ALL     — reset to root on logout
 *
 * Accepted as a factory so that `history` is injected rather than imported
 * from store.js (which would create a circular dependency).
 *
 * @param {import('history').History} history
 */
const createUrlSyncMiddleware = (history) => store => next => action => {
  const result = next(action);

  const { selectedTabId, openTabs } = store.getState().mainTabs;

  if (action.type === MAINTAB.SELECT) {
    const activeTab = openTabs.find(t => t.tabId === selectedTabId);
    if (activeTab) {
      const newPath = tabToPath(activeTab);
      if (newPath && history.location.pathname !== newPath) {
        history.push(newPath);
      }
    }
  }

  if (action.type === MAINTAB.CHANGE_METADATA && action.tabId === selectedTabId) {
    const activeTab = openTabs.find(t => t.tabId === selectedTabId);
    if (activeTab) {
      const newPath = tabToPath(activeTab);
      if (newPath && history.location.pathname !== newPath) {
        history.push(newPath);
      }
    }
  }

  if (action.type === MAINTAB.CLOSE_ALL) {
    if (history.location.pathname !== '/') {
      history.push('/');
    }
  }

  return result;
};

export default createUrlSyncMiddleware;
